export default __webpack_public_path__ + "static/media/landingPageImage.1de245e2.svg";